import { apiClient, unwrap } from './client';
import type { ApiResponse, PagedResult } from '@/types/api';
import type {
  MdmDto,
  CreateMdmRequest,
  UpdateMdmRequest,
  MdmListRequest,
  MdmCredentialsValidationResult,
} from '@/types/mdm';

export const mdmsApi = {
  list(request: MdmListRequest = {}): Promise<PagedResult<MdmDto>> {
    return unwrap(
      apiClient.get<ApiResponse<PagedResult<MdmDto>>>('/mdms', { params: request }),
    );
  },

  /** Lista compacta para el selector del header. */
  getAccessible(): Promise<MdmDto[]> {
    return unwrap(
      apiClient.get<ApiResponse<MdmDto[]>>('/mdms/accessible'),
    );
  },

  getById(id: number): Promise<MdmDto> {
    return unwrap(apiClient.get<ApiResponse<MdmDto>>(`/mdms/${id}`));
  },

  create(request: CreateMdmRequest): Promise<MdmDto> {
    return unwrap(apiClient.post<ApiResponse<MdmDto>>('/mdms', request));
  },

  update(id: number, request: UpdateMdmRequest): Promise<MdmDto> {
    return unwrap(apiClient.put<ApiResponse<MdmDto>>(`/mdms/${id}`, request));
  },

  deactivate(id: number): Promise<void> {
    return apiClient.post(`/mdms/${id}/deactivate`).then(() => undefined);
  },

  reactivate(id: number): Promise<void> {
    return apiClient.post(`/mdms/${id}/reactivate`).then(() => undefined);
  },

  validateCredentials(id: number): Promise<MdmCredentialsValidationResult> {
    return unwrap(
      apiClient.post<ApiResponse<MdmCredentialsValidationResult>>(`/mdms/${id}/validate-credentials`),
    );
  },

  setDefault(id: number): Promise<void> {
    return apiClient.post(`/mdms/${id}/set-default`).then(() => undefined);
  },

  clearAmapiCache(): Promise<void> {
    return apiClient.post('/mdms/clear-amapi-cache').then(() => undefined);
  },
};
